export const CREDIT_TERM_DAYS = [30, 60, 90];
